import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const DropboxIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Dropbox Icon</title>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g fill="#0061FF"><g><g transform="translate(1.558442 3.740260)"><path d="M21.7184518,9.1750322 L28.8942338,13.7465974 L21.6679481,18.3503377 L14.447065,13.7501055 L7.22628571,18.3503377 L0,13.7465974 L7.17567842,9.17509816 L0,4.60363636 L7.22638961,0 L14.4470131,4.60016145 L21.6680519,0 L28.8941299,4.60363636 L21.7184518,9.1750322 Z M21.61734,9.17509816 L14.447013,4.60711128 L7.27678947,9.1750322 L14.447065,13.7430893 L21.61734,9.17509816 Z M7.27272727,19.8759481 L14.499013,15.2727273 L21.7254026,19.8759481 L14.499013,24.4796883 L7.27272727,19.8759481 Z" /></g></g></g></g>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};